import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal'

/* Icons */
import CrossIcon from '~/../symbols/cross.svg';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function Modal({
    open,
    handleClose,
    backText = trans(`app.modal.back`),
    closeText = trans(`app.modal.close`),
    modalBody = null,
    className,
}) {
    return (
        <BootstrapModal
            centered
            show={open}
            onHide={handleClose}
            className={className}
        >
            <BootstrapModal.Body>
                <Button
                    className="p-0 modal-close"
                    theme="none"
                    title={closeText}
                    showTitle={false}
                    icon={CrossIcon}
                    iconSize={14}
                    iconClassName={'icon--lg-16'}
                    withCircle={false}
                    onClick={handleClose}
                />
                {modalBody}
            </BootstrapModal.Body>
        </BootstrapModal>
    )
}
